/* lib/chunkReload.js — восстановление после выката, когда ленивый раздел не загрузился.

   Открытая вкладка держит index.html прежней сборки, а `vite build` при выкате чистит dist:
   чанки, на которые ссылается старый главный бандл, на сервере уже удалены (404). Раздел,
   который вкладка ещё не открывала, тогда не грузится — одна перезагрузка страницы берёт новый
   index.html и новые чанки. Правила:
   · не чаще раза в RELOAD_WINDOW_MS — если чанка нет и в свежей сборке, человек видит ошибку с
     кнопкой, а не цикл перезагрузок;
   · без сети (navigator.onLine === false) не перезагружаем: вместо приложения браузер показал
     бы свою страницу «Нет подключения»;
   · отметку негде сохранить (хранилище выключено) — тоже не перезагружаем: без отметки цикл не
     остановить;
   · несохранённое не теряется: при грязной форме перезагрузку останавливает beforeunload
     сторожа (UnsavedChangesProvider) — браузер спросит сам. */

export const RELOAD_KEY = 'restorium.chunk_reload_at';
export const RELOAD_WINDOW_MS = 30000;

export function shouldReload({ now, lastAt, online }) {
  if (online === false) return false;
  if (lastAt != null && now - lastAt >= 0 && now - lastAt < RELOAD_WINDOW_MS) return false;
  return true;
}

export function reloadForFreshBuild(win = typeof window !== 'undefined' ? window : null) {
  if (!win || !win.location || typeof win.location.reload !== 'function') return false;
  let lastAt = null;
  try {
    const raw = win.sessionStorage.getItem(RELOAD_KEY);
    lastAt = raw ? Number(raw) || null : null;
  } catch (_) { return false; }
  const now = Date.now();
  const online = win.navigator ? win.navigator.onLine : undefined;
  if (!shouldReload({ now, lastAt, online })) return false;
  try { win.sessionStorage.setItem(RELOAD_KEY, String(now)); } catch (_) { return false; }
  win.location.reload();
  return true;
}
